/**
 * Utilidades de criptografía para el proyecto
 */

/**
 * Genera el hash SHA256 de una cadena de texto usando la Web Crypto API del navegador
 * @param text Texto a hashear
 * @returns Promise con el hash SHA256 en formato hexadecimal
 */
export async function hashSHA256(text: string): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(text);
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
	return hashHex;
}

/**
 * Encripta una contraseña usando el mismo patrón que el login:
 * 1. Primer nivel: SHA256(password)
 * 2. Segundo nivel: SHA256(primerHash + timestamp)
 *
 * @param password Contraseña en texto plano
 * @param timestamp Timestamp en milisegundos (opcional)
 * @returns Promise con la contraseña encriptada
 */
export async function encryptPasswordWithTimestamp(password: string, timestamp?: number): Promise<string> {
	// Primer nivel de encriptación
	const levelOneEncryption = await hashSHA256(password);

	// Si hay timestamp, hacemos el segundo nivel de encriptación
	if (timestamp) {
		const levelTwoEncryption = await hashSHA256(levelOneEncryption + timestamp);
		return levelTwoEncryption;
	}

	return levelOneEncryption;
}
